export const managementSavedConfigConsistencyMessages = {
  en: {
    boxTitle: 'Saved config consistency',
    configActionColumnTitle: 'Config',
    btnChanges: 'Changes',
    btnStartupConfig: 'Startup',
    btnCurrentConfig: 'Current',
    diff: {
      backButton: 'Back to config list',
      title: 'Startup vs. Current config',
    },
  },
};
